import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'white';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  isLoading,
  children,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-primary-700 text-white hover:bg-primary-800 shadow-sm',
    secondary: 'bg-accent-700 text-white hover:bg-accent-800 shadow-sm',
    outline: 'border-2 border-primary-700 text-primary-700 hover:bg-primary-50',
    ghost: 'text-primary-700 hover:bg-primary-50',
    white: 'bg-white text-primary-900 hover:bg-gray-100 shadow-sm'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={cn('inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], className)} ref={ref} disabled={isLoading || props.disabled} {...props} data-id="element-103">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-104" />}
        {children}
      </button>;
});
Button.displayName = 'Button';
export { Button };